/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthService, NbAuthResult } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'ngx-reset-password-page',
  styleUrls: ['./reset-password.component.scss'],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxResetPasswordComponent implements OnInit {
  minLength: number = 8;
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.resetPassword.redirectDelay');
  showMessages: any = this.getConfigValue('forms.resetPassword.showMessages');
  strategy: string = this.getConfigValue('forms.resetPassword.strategy');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  resetPasswordForm: FormGroup;
  @Input() tenantId: any;
  @Input() resetMobileNum: any;
 smsdto={"variables":[],"template_id":"","to":"","service":"T"};
  branchName: string; 
  showPassword: boolean = false;
  get apiUrl(): string {
    return environment.apiUrl;
  }
  protected readonly unsubscribe$ = new Subject<void>();

  constructor(protected service: NbAuthService,protected tenantSrvc: TenantData,protected patRegSrvc: PatientRegistrationData,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected fb: FormBuilder,
    protected router: Router) { }

  ngOnInit(): void {
    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])(?=.{8,})/)
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.resetPasswordForm = this.fb.group({
      password: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
      mobileNumber: this.fb.control(''),
    tenantId: this.fb.control(''),
    });
  }
  get password() { return this.resetPasswordForm.get('password'); }
  get confirmPassword() { return this.resetPasswordForm.get('confirmPassword'); }
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  hasUppercase(value: string): boolean {
    return /[A-Z]/.test(value);
  }

  hasLowercase(value: string): boolean {
    return /[a-z]/.test(value);
  }

  hasNumeric(value: string): boolean {
    return /\d/.test(value);
  }

  hasSymbol(value: string): boolean {
    return /[!@#$%^&*()_+{}:<>?]/.test(value);
  }

  
  resetPass(): void {
    this.resetPasswordForm.controls["tenantId"].setValue(this.tenantId);
    this.resetPasswordForm.controls["mobileNumber"].setValue(this.resetMobileNum);

    this.errors = this.messages = [];
    this.submitted = true;
    this.user = this.resetPasswordForm.value;

    this.service.resetPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.diaClose.emit();
      } else {
        this.errors = result.getErrors();
      }

      // const redirect = result.getRedirect();
      // if (redirect) {
      //   setTimeout(() => {
      //     return this.router.navigateByUrl(redirect);
      //   }, this.redirectDelay);
      // }
      this.cd.detectChanges();

      this.fetchTenantBranch();
      this.smsdto.variables=[this.branchName];
      this.smsdto.template_id = "d3f23e1a-ba6d-4d43-b964-6c333ba8a806"; 

    // To call server side api for sms sending written by Abirami Paramasivam / 24.05.21
    this.patRegSrvc.sendgreetingsMessage("communication/" + this.tenantId + '/' + this.tenantId + '/send_greetings_message/' + this.resetMobileNum,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     }, (error) => {
     }, () => {
     });
    });
  }

  fetchTenantBranch(): void {
    this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     this.branchName = data.name;
    }, (error) => {
    }, () => {
    });
  }

  backToLogin()
  {
    this.diaClose.emit();
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
